var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        style: {
            width: '100%'
        },
        attrs: {
            "value": _vm.value,
            "title": "Cupón disponibles",
            "safeAreaInsetBottom": true,
            "position": "bottom",
            "closeable": "",
            "close-icon-position": "top-right",
            "teleport": "body",
            "round": ""
        },
        on: {
            "opened": _setup.onOpenedPopup,
            "closed": _setup.onClosedPopup,
            "click-overlay": function($event) {
                return _setup.emit('close');
            },
            "click-close-icon": function($event) {
                return _setup.emit('close');
            }
        }
    }, [
        _c('div', [
            _vm._l(_vm.couponList, function(item) {
                return _c('div', {
                    key: item.eCouponCode,
                    class: _vm.$style.couponBox
                }, [
                    _c('div', {
                        class: _vm.$style.top
                    }, [
                        item.discountCode === 1 || item.discountCode === 3 ? _c('div', {
                            class: _vm.$style.left
                        }, [
                            _c('span', [
                                _vm._v(_vm._s(item.priceCut))
                            ]),
                            _c('i', [
                                _vm._v("%")
                            ])
                        ]) : _vm._e(),
                        item.discountCode === 2 || item.discountCode === 4 ? _c('div', {
                            class: _vm.$style.left
                        }, [
                            _c('span', [
                                _vm._v("$")
                            ]),
                            _c('span', [
                                _vm._v(_vm._s(_setup.formatAmount(item.priceCut, '0,0')))
                            ]),
                            _c('i', [
                                _vm._v(".00")
                            ])
                        ]) : _vm._e(),
                        _c('div', {
                            class: _vm.$style.right
                        }, [
                            _c('div', {
                                class: _vm.$style.detail
                            }, [
                                _c('p', {
                                    class: _vm.$style.title
                                }, [
                                    _c('span', {
                                        class: _vm.$style.titleText
                                    }, [
                                        _vm._v("Reducción de intereses")
                                    ]),
                                    _c('img', {
                                        attrs: {
                                            "src": require("@/assets/img/repay/question-icon.png"),
                                            "alt": ""
                                        },
                                        on: {
                                            "click": _setup.showCouponRules
                                        }
                                    })
                                ]),
                                _c('div', {
                                    class: _vm.$style.tags
                                }, _vm._l(item.couponDescList, function(item) {
                                    return _c('span', {
                                        key: item
                                    }, [
                                        _vm._v(_vm._s(item))
                                    ]);
                                }), 0),
                                _c('p', {
                                    class: _vm.$style.date
                                }, [
                                    _vm._v("Fecha límite: " + _vm._s(item.expiredAt))
                                ])
                            ])
                        ]),
                        _c('div', {
                            class: _vm.$style.selectBtn,
                            on: {
                                "click": function($event) {
                                    return _setup.selectCoupon(item);
                                }
                            }
                        }, [
                            _vm.eCouponCode === item.eCouponCode ? _c('img', {
                                attrs: {
                                    "src": require("@/assets/img/repay/selected-icon.png"),
                                    "alt": ""
                                }
                            }) : _c('img', {
                                attrs: {
                                    "src": require("@/assets/img/repay/unselect-icon.png"),
                                    "alt": ""
                                }
                            })
                        ])
                    ]),
                    _c('div', {
                        class: _vm.$style.bottom
                    }, [
                        _vm._v(" " + _vm._s(item.discountCap) + " ")
                    ]),
                    _c(_setup.CouponRulesPopup, {
                        attrs: {
                            "couponObj": item
                        },
                        on: {
                            "close": function($event) {
                                _setup.isCouponRulesShow = false;
                            }
                        },
                        model: {
                            value: _setup.isCouponRulesShow,
                            callback: function callback($$v) {
                                _setup.isCouponRulesShow = $$v;
                            },
                            expression: "isCouponRulesShow"
                        }
                    })
                ], 1);
            }),
            _c('div', {
                class: _vm.$style.noUseCoupon
            }, [
                _c('p', [
                    _vm._v("No utilizar cupón")
                ]),
                _vm.eCouponCode === '-1' ? _c('img', {
                    class: _vm.$style.selectBtn,
                    attrs: {
                        "src": require("@/assets/img/repay/selected-icon.png"),
                        "alt": ""
                    },
                    on: {
                        "click": function($event) {
                            return _setup.selectCoupon(null);
                        }
                    }
                }) : _c('img', {
                    class: _vm.$style.selectBtn,
                    attrs: {
                        "src": require("@/assets/img/repay/unselect-icon.png"),
                        "alt": ""
                    },
                    on: {
                        "click": function($event) {
                            return _setup.selectCoupon(null);
                        }
                    }
                })
            ])
        ], 2)
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
